// Copyright (c) 2023 Deere & Company

import SearchFilters from '../../../shared/state/search-filters';
import actions from '../../actions-list';
import {getDefaultState as getWipDefaultState} from '../state';

const resetSearchFilters = state =>
    SearchFilters.update(state, {
        $set: getWipDefaultState().duplicatePinPlateSearchFilters
    });

const updateSearchFilters = (state, action) =>
    SearchFilters.update(state, {
        [action.property]: {
            $set: action.payload
        }
    });

export default (state = getWipDefaultState().duplicatePinPlateSearchFilters, action) => {

    const actionTypes = {
        [actions.RESET_TCSM_DUPLICATE_PIN_PLATE_SEARCH_FILTERS]: resetSearchFilters,
        [actions.UPDATE_TCSM_DUPLICATE_PIN_PLATE_FILTER_BY]: updateSearchFilters,
        [actions.UPDATE_TCSM_DUPLICATE_PIN_PLATE_SORT_BY]: updateSearchFilters,
        [actions.UPDATE_TCSM_DUPLICATE_PIN_PLATE_SORT_DIRECTION]: updateSearchFilters
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/tcsm/wip/reducers/duplicate-pin-plate-search-filters.js